import React, { useState, useRef, useEffect } from "react";
import { Button, Menu, MenuItem } from "@mui/material";

const Filteration = ({ setLiftingStatus }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [buttonWidth, setButtonWidth] = useState(0);
  const buttonRef = useRef(null);

  const open = Boolean(anchorEl);

  // Measure button width on mount and when anchor changes
  useEffect(() => {
    if (buttonRef.current) {
      setButtonWidth(buttonRef.current.offsetWidth);
    }
  }, [anchorEl]);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleStatusSelect = (status: string) => {
    setLiftingStatus(status);
    handleClose();
  };

  return (
    <div
      style={{
        marginRight: "20px",
        width: "100%",
        display: "flex",
        justifyContent: "flex-end",
        padding: "20px",
      }}
    >
      <Button
        ref={buttonRef} // Attach ref to Button to measure width
        variant="outlined"
        className="text-hover-primary"
        onClick={handleClick}
        sx={{
          height: 40,
          minWidth: 180,
          border: "1px solid #ccc",
          display: "flex",
          gap: "10px",
          overflow: "hidden",
          textTransform: "none",
          whiteSpace: "nowrap",
        }}
      >
        <i className="bi bi-filter text-dark fs-4" />
        <span
          className="me-2 fw-100"
          style={{
            fontSize: "15px",
            fontFamily: "karbon",
            fontWeight: 100,
            color: "#666666",
            textOverflow: "ellipsis",
            overflow: "hidden",
          }}
        >
          Search Filter
        </span>
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          style: {
            width: buttonWidth, // Set Menu width same as Button
          },
        }}
      >
        <MenuItem
          onClick={() => handleStatusSelect("scheduled")}
          style={{ fontFamily: "karbon", color: "#666666" }}
        >
          Scheduled
        </MenuItem>
        <MenuItem
          onClick={() => handleStatusSelect("rescheduled")}
          style={{ fontFamily: "karbon", color: "#666666" }}
        >
          Rescheduled
        </MenuItem>
        <MenuItem
          onClick={() => handleStatusSelect("missed")}
          style={{ fontFamily: "karbon", color: "#666666" }}
        >
          Missed
        </MenuItem>

        <MenuItem
          onClick={() => handleStatusSelect("cancelled")}
          style={{ fontFamily: "karbon", color: "#666666" }}
        >
          Cancelled
        </MenuItem>
        <MenuItem
          onClick={() => handleStatusSelect("completed")}
          style={{ fontFamily: "karbon", color: "#666666" }}
        >
          Completed
        </MenuItem>
      </Menu>
    </div>
  );
};

export default Filteration;
